<div class="component-securities-container">
  <div class="component-securities-container-row">
    <div class="component-securities-container-element">
      <strong id="rowCount">{{rowCount == 1 ? rowCount + " component security" : rowCount + " component securities"}}</strong>
      <span id="componentSecuritiesCompToolTipIcon"
        class="infoIcon" calltoaction
      [calltoactionTemplate]="componentSecuritiesToolTipTemplateRef"></span>
    </div>
  </div>
  <ng-template #componentSecuritiesToolTipTemplateRef>
    <div>
      <div>
        <strong>Component Securities</strong>
        <p>Securities specified here are components of this group security.</p>
      </div>
      <div style="margin-top:10px">
        <p>Adding securities that currently exist in the iRebal security master will remove them from the
          security master. Securities which are currently being used as model targets cannot be added as
        components of a group security.</p>
      </div>
    </div>
  </ng-template>
  <div class="component-securities-container-row">
    <div>
      <span>
        Add a security to this group:
      </span>
      <irb-dropdown-search-multiple #securitiesDropdown [(values)]="securitiesList" [enableHiddenSearchResults]="true"
        (search)="getFilteredListOfSecurities($event)" (selection)="onSecuritiesChange($event)"
        style="width: 300px !important;vertical-align: middle; margin-right: 4px;" size="30">
      </irb-dropdown-search-multiple>
      <button (click)="addSecuritiesFromDropdown()" [disabled]="securitiesList ? securitiesList.length === 0 : true" class="btn-medium-primary">Add</button>
      <button  id="editComponentSecuritiesCreateNewBtn" (click)="onCreateNewSecurity()" class="btn-medium-secondary">New Security</button>
    </div>
  </div>
  <div class="component-securities-container-row">
    <div class="add-mult-securities-container">
      <span>Add multiple securities to this group: </span>
      <button  id="addMultipleSecuritiesButton" (click)="showAddMultipleSecuritiesDialog()" class="btn-medium-secondary">Advanced Filter</button>
    </div>
  </div>
  <div class="component-securities-grid">
    @if (!isUiTest) {
      <irb-inventory-grid [style.width]="'60%'" [style.height]="'200px'"
        [style.margin-top]="'10px'" [showSideBar]="false" [gridOptions]="gridOptions"
      [frameworkComponents]='frameworkComponents' (gridReady)="onGridReady($event)"></irb-inventory-grid>
    }
  </div>
</div>
